import { Line } from "@visx/shape";
import { useTheme } from "@mui/material";
import useAreaChartActions from "../AreaChartProvider/useAreaChartActions";
import useAreaChart from "../AreaChartProvider/useAreaChartStore/useAreaChartStore";
import useDrawing from "../DrawingProvider/useDrawingStore/useDrawingStore";
import { useCallback } from "react";
import { Coordinates } from "../DrawingProvider";

function Cursor() {
  const theme = useTheme();
  const { coordinates } = useDrawing();
  const { onCursorClick } = useAreaChartActions();
  const { height, margin } = useAreaChart();

  const handleOnClick = useCallback(
    (data: Coordinates) => (e: React.MouseEvent<SVGGElement>) => {
      onCursorClick?.(e, data);
    },
    [onCursorClick]
  );

  if (!coordinates.length) return null;

  return (
    <>
      <Line
        from={{ x: coordinates[0].x, y: margin.top }}
        to={{ x: coordinates[0].x, y: height - margin.top }}
        stroke={theme.palette.grey[60]}
        strokeWidth={1}
        pointerEvents="none"
      />
      {coordinates.map((item, i) => (
        <g key={i} pointerEvents="all" onClick={handleOnClick(item)}>
          <circle cx={item.x} cy={item.y} r={5} fill={item.color || theme.palette.grey[60]} />
          <circle cx={item.x} cy={item.y} r={10} fill={item.color || theme.palette.grey[60]} opacity={0.2} />
        </g>
      ))}
    </>
  );
}

export default Cursor;
